import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Hero = ({ link, img, text }: HeroProps): JSX.Element => {
	return (
		<Container>
			<StyledLink to={link}>
				<Banner $src={img}>
					<Text>{text}</Text>
				</Banner>
			</StyledLink>
		</Container>
	);
};

const StyledLink = styled(Link)`
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
`;

const Banner = styled.div<BannerProps>`
	width: 100%;
	height: 400px;
	background-image: ${props => (props.$src ? `url("${props.$src}")` : '')};
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 75%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding-left: 3rem;

	@media (max-width: 992px) {
		width: 100vw;
		margin: 0 -24px;
	}
	@media (max-width: 600px) {
		padding-left: 1rem;
		width: 100vw;
		height: 240px;
		margin: 0 -16px;
	}
`;

interface BannerProps {
	$src: string;
}
export interface HeroProps {
	link: string;
	img: string;
	text: string;
}

const Container = styled.div`
	position: relative;
	text-align: center;
	color: rgb(255, 255, 255);
	margin-top: -36px;

	@media (max-width: 1200px) {
		margin-top: -60px;
	}

	@media (max-width: 768px) {
		margin-top: 0;
	}
`;

const Text = styled.h1`
	text-align: left;
	color: #f8f8f2 !important;
	font-weight: 500;
	font-size: 32px;
	line-height: 120%;
	width: 40%;

	@media (max-width: 768px) {
		font-size: 18px;
	}
	@media (max-width: 600px) {
		font-size: 18px;
	}
`;
